import { FetchAdapter } from "../../../commons/FetchAdapter/FetchAdapter";

export class HermesClient {
  static timeoutPromise(ms, promise) {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error("promise timeout"))
      }, ms);
      promise.then(
        (res) => {
          clearTimeout(timeoutId);
          resolve(res);
        },
        (err) => {
          clearTimeout(timeoutId);
          reject(err);
        }
      );
    })
  }
  
  static hitHermesEndpoint(endpoint) {
    return HermesClient.timeoutPromise(1000, FetchAdapter.get(endpoint))
      .then(response => response.json())
  }
}
